import React, { useContext } from 'react'
import { OrgContext } from '../../contexts/org-context'
import { useRouteOrgId } from '../../hooks/use-route-org-id'
import { OrgDashboardPage } from './org-dashboard-page'

export const OrgDashboardRoute: React.FC = () => {
    const orgId = useRouteOrgId()
    const { org } = useContext(OrgContext)
    return <OrgDashboardPage orgId={orgId} org={org} />
}
export default OrgDashboardRoute
